export default __webpack_public_path__ + "static/media/fMaltoBuza35.1658e34f.png";